import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import './header.css';

const Header = () => {
  let location = useLocation();
  React.useEffect(() => {
    const active = {};
    let current = location.pathname.replace('/', '');
    active[current !== '' ? current : 'home'] = true;
    setActive(active);
  }, [location]);

  const [active, setActive] = useState({
    about: true,
  });
  const [navbarMobile, setNavbarMobile] = useState(false);

  const mobileNavToggle = () => {
    setNavbarMobile(!navbarMobile);
  };

  return (
    <header id="header" className="fixed-top">
      <div className="container d-flex align-items-center justify-content-between">
        <h1 className="logo">
          <Link to="/">JLAB</Link>
        </h1>

        <nav
          id="navbar"
          className={`navbar ${navbarMobile ? 'navbar-mobile' : ''}`}
        >
          <ul>
            <li>
              <Link
                className={`nav-link scrollto ${active.home ? 'active' : ''}`}
                to="/"
                onClick={() => setNavbarMobile(false)}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${active.about ? 'active' : ''}`}
                to="/about"
                onClick={() => setNavbarMobile(false)}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${
                  active.products ? 'active' : ''
                }`}
                to="/products"
                onClick={() => setNavbarMobile(false)}
              >
                Products
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${
                  active.services ? 'active' : ''
                }`}
                to="/services"
                onClick={() => setNavbarMobile(false)}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${
                  active.portfolio ? 'active' : ''
                }`}
                to="/portfolio"
                onClick={() => setNavbarMobile(false)}
              >
                Portfolio
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${active.team ? 'active' : ''}`}
                to="/team"
                onClick={() => setNavbarMobile(false)}
              >
                Team
              </Link>
            </li>
            <li>
              <Link
                className={`nav-link scrollto ${
                  active.contact ? 'active' : ''
                }`}
                to="/contact"
                onClick={() => setNavbarMobile(false)}
              >
                Contact
              </Link>
            </li>
          </ul>
          <i
            className={`bi mobile-nav-toggle ${
              navbarMobile ? 'bi-x' : 'bi-list'
            }`}
            onClick={() => mobileNavToggle()}
          ></i>
        </nav>
      </div>
    </header>
  );
};

export default Header;
